import React, { ReactNode } from "react";
import { TypographyVariant } from "./typography.types";
import { cn } from "@/lib/utils";

type TypographyProps = {
  variant?: TypographyVariant;
  as?: React.ElementType;
  className?: string;
  children: ReactNode;
  style?: React.CSSProperties;
};

const variantStyles: Record<TypographyVariant, string> = {
  h1: "text-display-sm leading-display-sm font-family-heading sm:text-display-md sm:leading-display-md lg:text-display-lg lg:leading-display-lg",
  h2: "text-display-xs leading-display-xs font-family-heading sm:text-display-sm sm:leading-display-sm lg:text-display-md lg:leading-display-md",
  h3: "text-xl leading-text-sm font-weight-demi font-family-heading sm:text-display-xs sm:leading-display-xs lg:text-display-sm lg:leading-display-sm",
  h4: "text-xs leading-text-xs font-family-heading sm:text-sm sm:leading-text-sm lg:text-display-xs lg:leading-display-xs",
  p: "text-md leading-text-md font-family-body",
  "p-sm":
    "text-xs leading-text-xs font-family-body sm:text-sm sm:leading-text-sm lg:text-md lg:leading-text-md",
  "p-lg":
    "text-md leading-text-md font-family-body sm:text-lg sm:leading-text-lg lg:text-xl lg:leading-text-xl",
};

export const Typography = ({
  variant = "p",
  as: Component = "p",
  className,
  children,
  ...props
}: TypographyProps) => {
  return (
    <Component className={cn(variantStyles[variant], className)} {...props}>
      {children}
    </Component>
  );
};
